<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :viewBox="`0 0 ${full ? '124.1' : '34.5'} 23`">
    <g id="symbols">
      <g id="_x30_2_x5F_Elements-UI_x2F_02_x5F_Logo_x2F_00_x5F_Brand_x2F_Logo-long">
        <g id="LOGO">
          <g id="Group" :transform="`${full ? 'translate(89.91)' : ''}`">
            <path
              id="Fill-1"
              d="M9.8.7c.1-.1.1-.1.2-.1s.1.1.1.2 0 .1-.1.2C7.9 3.6 6.3 6.8 6.3 11.2c0 4.4
              1.5 7.5 3.7 10.3.1.1.1.1.1.2s-.1.2-.1.2-.1 0-.2-.1l-9-9c-.5-.5-.8-.9-.8-1.6
              0-.7.3-1.1.7-1.5l9.1-9"
              fill="#FFFFFF"
            />
            <path
              id="Fill-3"
              class="st1"
              d="M17.4 0c-3.6 0-5.1 5.3-5.1 11.5 0 6.3 1.4 11.5 5.1 11.5 2.2 0 4-1.3 4-2.4
              0-.2-.1-.5-.3-.7-1-1-1.4-2-1.4-2.9 0-1.7 1.5-3 2.8-3 1.8 0 2.9 1.5 2.9 3.4 0
              1.8-.8 3.3-1.6 4.6v.2c0 .1.1.2.1.2.1 0 .1 0 .2-.1l9.3-9.2c.5-.4.8-.9.8-1.6
              0-.7-.3-1.1-.8-1.6L24.1.7h-.2c-.1 0-.1.1-.1.2v.2c.8 1.2 1.6 2.7 1.6 4.6 0
              1.9-1.1 3.4-2.9 3.4-1.3 0-2.8-1.3-2.8-3 0-.9.4-1.9 1.4-2.9.2-.2.3-.4.3-.7
              0-1.2-1.8-2.5-4-2.5"
              fill="#FFFFFF"
            />
          </g>
          <path
            v-if="full"
            id="Fill-5"
            class="st1"
            d="M1.9 16.3C.7 15.1 0 13.4 0 11.2c0-2.1.7-3.8 1.8-5 1.2-1.3 2.7-2 4.3-2C9 4.2
            11 6.3 11 8c0 .9-.6 1.7-1.4 1.7-.4 0-.8-.1-1-.4-.3-.2-.5-.6-.5-1.1
            0-.6.3-.9.5-1.1-.3-.7-1.1-1.2-2.3-1.2-1 0-1.8.5-2.4 1.5-.6.9-1 2.3-1 3.8 0
            1.6.4 2.9 1 3.8.6.9 1.5 1.5 2.5 1.5 1.2 0 1.9-.5 2.3-1.2-.2-.2-.5-.6-.5-1.1
            0-.5.2-.8.4-1.1.3-.3.6-.4 1-.4.8 0 1.4.7 1.4 1.7 0 1.8-2 3.8-4.9
            3.8-1.6-.1-3.1-.7-4.2-1.9zm0 0C.7 15.1 0 13.4 0 11.2c0-2.1.7-3.8 1.8-5 1.2-1.3
            2.7-2 4.3-2C9 4.2 11 6.3 11 8c0 .9-.6 1.7-1.4 1.7-.4
            0-.8-.1-1-.4-.3-.2-.5-.6-.5-1.1 0-.6.3-.9.5-1.1-.3-.7-1.1-1.2-2.3-1.2-1
            0-1.8.5-2.4 1.5-.6.9-1 2.3-1 3.8 0 1.6.4 2.9 1 3.8.6.9 1.5 1.5 2.5 1.5 1.2 0
            1.9-.5 2.3-1.2-.2-.2-.5-.6-.5-1.1 0-.5.2-.8.4-1.1.3-.3.6-.4 1-.4.8 0 1.4.7 1.4
            1.7 0 1.8-2 3.8-4.9 3.8-1.6-.1-3.1-.7-4.2-1.9zm0 0C.7 15.1 0 13.4 0
            11.2c0-2.1.7-3.8 1.8-5 1.2-1.3 2.7-2 4.3-2C9 4.2 11 6.3 11 8c0 .9-.6 1.7-1.4
            1.7-.4 0-.8-.1-1-.4-.3-.2-.5-.6-.5-1.1 0-.6.3-.9.5-1.1-.3-.7-1.1-1.2-2.3-1.2-1
            0-1.8.5-2.4 1.5-.6.9-1 2.3-1 3.8 0 1.6.4 2.9 1 3.8.6.9 1.5 1.5 2.5 1.5 1.2 0
            1.9-.5 2.3-1.2-.2-.2-.5-.6-.5-1.1 0-.5.2-.8.4-1.1.3-.3.6-.4 1-.4.8 0 1.4.7 1.4
            1.7 0 1.8-2 3.8-4.9 3.8-1.6-.1-3.1-.7-4.2-1.9zm41.5-4.6c.2 0 .2 0
            .3-.1v-.4c0-.9-.7-1.8-1.8-1.8-1.3 0-1.9 1.1-2 2.2l3.5.1zm-26.8 1.6c-1
            0-1.7.5-1.7 1.5 0 .9.6 1.5 1.6 1.6.6 0 1.3-.4
            1.7-.9v-1.4c0-.2-.1-.4-.4-.5-.3-.2-.7-.3-1.2-.3zm39.4-.6c0 2.6 1.1 3.8 2.2 3.8
            1.3 0 2.2-1.1 2.2-3.3 0-1.2-.2-2.1-.7-2.7-.4-.6-1-1-1.6-1-1.3 0-2.1 1.2-2.1
            3.2zm-32.7 5c-.4-.1-.7-.3-.7-.7 0-.1 0-.3.1-.4h.1c.2 0
            .4-.1.6-.3.2-.2.3-.5.3-1.3v-4c0-.7-.2-.9-.7-.9h-.5V10c-.1-.2-.1-.3-.1-.4
            0-.8.9-1.2 1.5-1.4.2-.1.4-.1.6-.1.8 0 1.2.6 1.4 1.3.6-.9 1.4-1.4 2.2-1.4.7 0
            1.5.5 1.5 1.5 0 .7-.5 1.4-1.3 1.4-.6 0-1.1-.4-1.2-1-.4.1-1.1.7-1.1 2.7V15c0
            .8.1 1.1.3 1.3.2.2.7.3.8.3h.1c.1.2.1.3.1.5 0
            .3-.2.5-.6.7-.4.1-.9.2-1.7.2-.7-.1-1.3-.2-1.7-.3zm7.8 0c-.4-.1-.7-.3-.7-.7
            0-.1 0-.3.1-.4h.1c.2 0
            .4-.1.6-.3.2-.2.3-.5.3-1.3v-4c0-.7-.2-.9-.7-.9h-.5V10c-.1-.2-.1-.3-.1-.4
            0-.8.9-1.2 1.4-1.4.2-.1.4-.1.6-.1.8 0 1.2.6 1.4 1.3.7-.9 1.5-1.4 2.3-1.4.7 0
            1.5.5 1.5 1.5 0 .7-.5 1.4-1.3 1.4-.6 0-1.1-.4-1.2-1-.4.1-1.1.7-1.1 2.7V15c0
            .8.1 1.1.3 1.3.2.2.7.3.8.3h.1c.1.2.1.3.1.5 0 .3-.2.5-.6.7-.4.1-1
            .2-1.7.2-.7-.1-1.2-.2-1.7-.3zm16.6 0c-.4-.1-.7-.3-.7-.7 0-.1 0-.3.1-.4h.1c.2
            0 .4-.1.6-.3.2-.2.3-.5.3-1.3V9.7h-1.4v-.1c-.1-.2-.1-.3-.1-.5
            0-.5.4-.9.9-.9h.6v-.5c0-1.4.3-2.2.6-2.7.5-.9 1.5-1.4 2.9-1.4 1.8 0 3.3.9 3.3
            2.2.1.5-.3 1.2-1.2 1.2-.6 0-1.2-.5-1.2-1.2 0-.3.1-.5.2-.7-.2-.2-.5-.3-.9-.3-.6
            0-.9.2-1.1.5-.2.3-.3.8-.3 1.3v1.5h2.4v.1c.2.3.2.4.2.6 0 .5-.4.9-.8 1h-1.6V15c0
            .8.1 1.1.4 1.3.2.2.8.3 1 .3h.1c.1.1.1.3.1.4 0 .4-.3.6-.7.7-.4.1-1.1.2-1.9.2-.9
            0-1.5-.1-1.9-.2zm28.3 0c-.4-.1-.7-.3-.7-.7 0-.1 0-.3.1-.4h.1c.2 0
            .4-.1.6-.3.2-.2.3-.5.3-1.3v-4c0-.7-.2-.9-.7-.9h-.5V10c-.1-.2-.1-.3-.1-.4
            0-.8.9-1.2 1.4-1.4.2-.1.4-.1.6-.1.8 0 1.2.6 1.4 1.3.6-.9 1.4-1.4 2.2-1.4.8 0
            1.5.5 1.5 1.5 0 .7-.5 1.4-1.3 1.4-.6 0-1.1-.4-1.2-1-.4.1-1.1.7-1.1 2.7V15c0
            .8.1 1.1.3 1.3.2.2.7.3.9.3h.1c.1.2.1.3.1.5 0
            .3-.2.5-.6.7-.4.1-.9.2-1.7.2-.7-.1-1.3-.2-1.7-.3zm-17.9.3c-1.3
            0-2.5-.5-3.4-1.4-.9-.9-1.4-2.1-1.4-3.6 0-3 2.3-5 4.9-5 1.4 0 2.6.5 3.4 1.4.9.9
            1.4 2.1 1.4 3.6s-.5 2.7-1.4 3.6c-.9.9-2.1 1.4-3.5 1.4zm-20.7-4.8c0-1.5.5-2.8
            1.3-3.7.9-1 2.1-1.5 3.5-1.5 1.3 0 2.3.5 2.9 1.2.6.7.9 1.6.9 2.5 0 .5-.1 1-.3
            1.4v.1h-5.8C40 14.8 41.1 16 43 16c1.2 0 2-.6 2.3-1l.1-.1.1.1c.2.1.3.3.3.8 0
            1-1.2 2.3-3.7 2.3-2.6-.1-4.7-2.2-4.7-4.9zm33.7
            4.4c-.2-.2-.3-.6-.3-.9l-.4.4c-.6.6-1.4 1-2.4
            1s-1.9-.4-2.4-1c-.8-1-.8-2.3-.8-4.2v-1.8c0-.7-.2-1-.9-1h-.4V10c-.1-.1-.1-.3-.1-.4
            0-.9 1.1-1.3 1.7-1.4.2 0 .4-.1.6-.1.5 0 .9.2 1.1.5.2.3.3.7.3 1.2v3c0 1.1.1 2
            .3 2.5.2.5.6.8 1.3.8.7 0 1.2-.3
            1.5-.8.3-.5.4-1.1.4-1.8v-2.4c0-.7-.2-1-.9-1h-.4V10c-.1-.1-.1-.3-.1-.4 0-.9
            1.1-1.3 1.7-1.4.2 0 .4-.1.6-.1.5 0 .9.2 1.1.5.2.3.3.7.3 1.2v5.3c0 .7.3 1.1.9
            1.1h.3v.1c.1.1.1.3.1.4 0 .8-1.1 1.2-1.7 1.3-.2
            0-.4.1-.6.1-.3-.1-.6-.2-.8-.5zm-58.8-2.7c0-1 .4-1.7 1.1-2.2.7-.5 1.7-.8
            2.8-.8.7 0 1.4.1 1.9.4v-1.1c0-1.1-.4-1.7-1.6-1.7-.2 0-.7.1-1.1.2 0 .2.1.3.1.5 0
            .4-.1.7-.3.9-.2.2-.5.4-.9.4-.7 0-1.2-.6-1.2-1.3C13 8.9 14.6 8 16.7 8c1.6 0
            2.7.4 3.2 1.1.5.7.5 1.6.5 2.9v3.5c0 .7.4.9 1.2 1h.1v.1c0 .9-.7 1.3-1.4
            1.4h-.2c-.7 0-1.4-.4-1.7-1.1-.4.4-1.4 1.1-2.7 1.1-1.9 0-3.4-1.3-3.4-3.1z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CarrefourLogo",

  props: {
    full: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>
